(() => {
  const selector = '[data-pilot-hub-section]';
  const controllers = window.__ytteronPilotHubControllers || new Map();
  window.__ytteronPilotHubControllers = controllers;
  function init(root) {
    if (!root || root.dataset.pilotReaderInitialized === 'true') return;
    root.dataset.pilotReaderInitialized = 'true';
    const reader = root.querySelector('[data-pilot-reader]');
    const empty = root.querySelector('[data-pilot-reader-empty]');
    const articles = [...root.querySelectorAll('.yt-pilot-article')];
    const triggers = [...root.querySelectorAll('[data-pilot-reader-trigger]')];
    const cardToggles = [...root.querySelectorAll('[data-pilot-card-toggle]')];
    if (!reader || !empty || !articles.length || !triggers.length) return;
    const sectionId = root.dataset.pilotHubSection;
    controllers.get(sectionId)?.abort();
    const controller = new AbortController();
    controllers.set(sectionId, controller);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function normalize(value) {
      return (value || '').replace(/\s+/g, ' ').trim();
    }
    function parentLabel(article) {
      const trigger = triggers.filter((item) => item.hash === `#${article.id}` || item.getAttribute('aria-controls') === article.id).find((item) => item.closest('.yt-pilot-group'));
      const heading = trigger?.closest('.yt-pilot-group')?.querySelector('.yt-pilot-group__identity h2');
      return normalize(heading?.textContent).replace(/^\d+\s*\/\s*/, '') || 'PILOT HUB';
    }
    function prepareArticle(article) {
      if (article.dataset.pilotHeaderReady === 'true') return;
      const kicker = [...article.children].find((child) => child.matches?.('.yt-pilot-kicker'));
      const title = [...article.children].find((child) => child.matches?.('h2'));
      if (!kicker || !title) return;
      const firstPage = [...article.children].find((child) => child.matches?.('.yt-pilot-page'));
      const leadingHeadings = [];
      if (firstPage) {
        for (const child of firstPage.children) {
          if (!child.matches('h3')) break;
          leadingHeadings.push(child);
        }
      }
      const sourceHeading = normalize(leadingHeadings.map((heading) => heading.textContent).join(' '));
      const mainTitle = normalize(title.textContent);
      title.dataset.pilotDefaultTitle = mainTitle;
      let deckText = sourceHeading;
      if (sourceHeading.toLowerCase().startsWith(mainTitle.toLowerCase())) {
        deckText = normalize(sourceHeading.slice(mainTitle.length).replace(/^\s*[-–—:]\s*/, ''));
      }
      const intro = leadingHeadings.length ? leadingHeadings[leadingHeadings.length - 1].nextElementSibling : null;
      const header = document.createElement('header');
      header.className = 'yt-pilot-article__header';
      const headingBlock = document.createElement('div');
      headingBlock.className = 'yt-pilot-article__heading';
      kicker.textContent = `PILOT HUB GUIDE · ${parentLabel(article)}`;
      headingBlock.append(kicker, title);
      if (deckText && deckText.toLowerCase() !== mainTitle.toLowerCase()) {
        const deck = document.createElement('p');
        deck.className = 'yt-pilot-article__deck';
        deck.textContent = deckText;
        headingBlock.append(deck);
      }
      if (intro?.matches('p')) {
        intro.classList.add('yt-pilot-article__intro');
        headingBlock.append(intro);
      }
      const selectionIntro = document.createElement('p');
      selectionIntro.className = 'yt-pilot-article__intro yt-pilot-article__selection-intro';
      selectionIntro.hidden = true;
      headingBlock.append(selectionIntro);
      leadingHeadings.forEach((heading) => heading.remove());
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'yt-pilot-reader__close';
      close.dataset.pilotReaderClose = '';
      close.setAttribute('aria-label', `Close ${mainTitle}`);
      close.textContent = 'Close guide ×';
      header.append(headingBlock, close);
      article.prepend(header);
      article.dataset.pilotHeaderReady = 'true';
    }
    articles.forEach(prepareArticle);
    function resolve(hash) {
      const id = decodeURIComponent((hash || '').replace(/^#/, ''));
      if (!id) return null;
      const target = root.querySelector(`#${CSS.escape(id)}`);
      if (!target) return null;
      const article = target.matches('.yt-pilot-article') ? target : target.closest('.yt-pilot-article');
      let subsections = article ? [...article.querySelectorAll(`[data-pilot-subsection="${CSS.escape(id)}"]`)] : [];
      const containingSubsection = target.closest?.('[data-pilot-subsection]');
      if (!subsections.length && containingSubsection) subsections = [containingSubsection];
      return article ? { id, target, article, subsections } : null;
    }
    function updateArticleHeader(selection) {
      if (!selection) return;
      const article = selection.article;
      const title = article.querySelector('.yt-pilot-article__heading h2');
      const kicker = article.querySelector('.yt-pilot-article__heading .yt-pilot-kicker');
      const deck = article.querySelector('.yt-pilot-article__deck');
      const sourceIntro = article.querySelector('.yt-pilot-article__intro:not(.yt-pilot-article__selection-intro)');
      const selectionIntro = article.querySelector('.yt-pilot-article__selection-intro');
      const cardTrigger = triggers.filter((trigger) => trigger.hash === `#${selection.id}`).find((trigger) => trigger.closest('.yt-pilot-cards'));
      const isSubsectionArticle = Boolean(article.querySelector('[data-pilot-subsection]'));
      if (title) title.textContent = isSubsectionArticle && cardTrigger ? normalize(cardTrigger.querySelector('strong')?.textContent) : title.dataset.pilotDefaultTitle;
      if (kicker) kicker.textContent = `PILOT HUB GUIDE · ${cardTrigger ? normalize(cardTrigger.closest('.yt-pilot-group')?.querySelector('.yt-pilot-group__identity h2')?.textContent).replace(/^\d+\s*\/\s*/, '') : parentLabel(article)}`;
      if (deck) deck.hidden = isSubsectionArticle;
      if (sourceIntro) sourceIntro.hidden = isSubsectionArticle;
      if (selectionIntro) {
        const summary = normalize(cardTrigger?.querySelector('.yt-pilot-card__description')?.textContent);
        selectionIntro.textContent = summary;
        selectionIntro.hidden = !isSubsectionArticle || !summary;
      }
    }
    function display(selection, options = {}) {
      reader.hidden = !selection;
      updateArticleHeader(selection);
      articles.forEach((article) => { article.hidden = !selection || article !== selection.article; });
      articles.forEach((article) => {
        article.querySelectorAll('[data-pilot-subsection]').forEach((subsection) => {
          subsection.hidden = Boolean(selection && article === selection.article && selection.subsections.length && !selection.subsections.includes(subsection));
        });
        article.querySelectorAll('[data-pilot-subsection-container]').forEach((container) => {
          container.hidden = Boolean(selection && article === selection.article && selection.subsections.length && !selection.subsections.some((subsection) => container.contains(subsection)));
        });
      });
      triggers.forEach((trigger) => {
        const active = Boolean(selection && trigger.getAttribute('href') === `#${selection.id}`);
        trigger.setAttribute('aria-expanded', String(active));
        if (active) trigger.setAttribute('aria-current', 'true');
        else trigger.removeAttribute('aria-current');
      });
      empty.hidden = true;
      if (!selection || !options.scroll) return;
      requestAnimationFrame(() => {
        selection.target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
        if (options.focus) {
          const heading = selection.article.querySelector('h2');
          if (heading) {
            heading.setAttribute('tabindex', '-1');
            heading.focus({ preventScroll: true });
          }
        }
      });
    }
    root.classList.add('is-reader-ready');
    const defaultVisibleCards = 5;
    const setCardGrid = (grid, expanded) => {
      const cards = [...grid.children].filter((child) => child.matches('a'));
      cards.forEach((card, index) => {
        card.hidden = !expanded && index >= defaultVisibleCards;
      });
      cardToggles.filter((toggle) => toggle.getAttribute('aria-controls') === grid.id).forEach((toggle) => {
        toggle.hidden = cards.length <= defaultVisibleCards;
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = `${expanded ? toggle.dataset.collapseLabel : toggle.dataset.expandLabel} ${expanded ? '←' : '→'}`;
      });
    };
    root.querySelectorAll('[data-pilot-card-grid]').forEach((grid) => setCardGrid(grid, false));
    const initial = resolve(window.location.hash);
    display(initial, { scroll: Boolean(initial) });
    root.addEventListener('click', (event) => {
      const cardToggle = event.target.closest('[data-pilot-card-toggle]');
      if (cardToggle && root.contains(cardToggle)) {
        const grid = root.querySelector(`#${CSS.escape(cardToggle.getAttribute('aria-controls'))}`);
        if (grid) setCardGrid(grid, cardToggle.getAttribute('aria-expanded') !== 'true');
        return;
      }
      const close = event.target.closest('[data-pilot-reader-close]');
      if (close && root.contains(close)) {
        const activeTrigger = triggers.find((trigger) => trigger.getAttribute('aria-current') === 'true');
        history.pushState({ pilotHub: null }, '', `${window.location.pathname}${window.location.search}`);
        display(null);
        if (activeTrigger) {
          activeTrigger.focus({ preventScroll: true });
          activeTrigger.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
        }
        return;
      }
      const trigger = event.target.closest('[data-pilot-reader-trigger]');
      if (!trigger || !root.contains(trigger)) return;
      const selection = resolve(trigger.hash);
      if (!selection) return;
      event.preventDefault();
      history.pushState({ pilotHub: selection.id }, '', trigger.hash);
      display(selection, { scroll: true, focus: true });
    }, { signal: controller.signal });
    const restore = () => display(resolve(window.location.hash), { scroll: true });
    window.addEventListener('popstate', restore, { signal: controller.signal });
    window.addEventListener('hashchange', restore, { signal: controller.signal });
  }
  function initAll(scope = document) {
    if (scope.matches?.(selector)) init(scope);
    scope.querySelectorAll?.(selector).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
